import BaseCompanyScopeEntityDto from '@/models/Shared/BaseCompanyScopeEntityDto';
import PositionDto from '@/models/Positions/PositionDto';
import ContactLocationDto from '@/models/ContactLocations/ContactLocationDto';
import NoteDto from '@/models/Notes/NoteDto';
import PersonDto from '@/models/Shared/Person';
import ContactStatus from '@/models/Contacts/ContactStatus';

export default class ContactDto extends BaseCompanyScopeEntityDto {
    legacyId = '';
    sequenceNumber = 0;
    status: ContactStatus = ContactStatus.Active;
    person: PersonDto = new PersonDto();
    emailAddress = '';
    isAgreedToMarketing = false;
    mobilePhoneNumber = '';
    otherPhoneNumber = '';
    positionId = '';
    position = new PositionDto();
    jobTitle = '';
    contactLocations: ContactLocationDto[] = [];
    notes: NoteDto[] = [];
    // canManageProfile: boolean;
    // canManageReports: boolean;
    // canManageUsers: boolean;
    // canManageRoles: boolean;
    // canManageLocations: boolean;
    // canManageBookings: boolean;
    // canManageWorkers: boolean;
    // canManageTimesheets: boolean;
}